import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import l10n from '../../../lang/locallang';

const videoSection = (param, is_public = false) => {
    const { videoPlaceholder, pasteYoutubeUrl, uploadVideoFile, videoUrlLabel, videoUrlHint, videoFileHint } = l10n.editor;

    let video_url = param.content && param.content.video_url ? param.content.video_url : '';
    let video_type = param.content && param.content.video_type ? param.content.video_type : '';
    let video_caption = param.content && param.content.video_caption ? param.content.video_caption : '';
    let video_thumbnail = param.content && param.content.video_thumbnail ? param.content.video_thumbnail : '';
    // Signed URLs for display/playback only (not stored in data attributes for saving)
    let video_url_signed = param.content && param.content.video_url_signed ? param.content.video_url_signed : video_url;
    let video_thumbnail_signed = param.content && param.content.video_thumbnail_signed ? param.content.video_thumbnail_signed : video_thumbnail;

    param.class = param.class ? param.class : 'editor-section editor-video';
    param.layout = param['@layout'] ? param['@layout'] : 'videoContainerWidth';
    param.style = param.style ? param.style : '';
    param.section = 'videoSection';

    let videoContent = '';

    if (video_url && video_type === 'youtube') {
        let embedUrl = convertToYoutubeEmbed(video_url);
        let videoId = extractYoutubeId(video_url);
        // If custom thumbnail — show thumbnail with play button, click loads iframe
        if (video_thumbnail) {
            videoContent = `<div class="video-player video-player--thumbnail" data-embed-url="${embedUrl}">
                <img class="video-thumbnail" src="${video_thumbnail_signed}" alt="Video thumbnail">
                <button class="video-play-btn" aria-label="Play video"></button>
            </div>`;
        } else if (videoId) {
            // Default YouTube thumbnail with play button (no iframe until click)
            let thumbUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
            videoContent = `<div class="video-player video-player--thumbnail" data-embed-url="${embedUrl}">
                <img class="video-thumbnail" src="${thumbUrl}" alt="Video thumbnail">
                <button class="video-play-btn" aria-label="Play video"></button>
            </div>`;
        } else {
            videoContent = `<div class="video-player">
                <iframe src="${embedUrl}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>`;
        }
    } else if (video_url && video_type === 'upload') {
        if (video_thumbnail) {
            videoContent = `<div class="video-player video-player--thumbnail" data-video-src="${video_url_signed}">
                <img class="video-thumbnail" src="${video_thumbnail_signed}" alt="Video thumbnail">
                <button class="video-play-btn" aria-label="Play video"></button>
            </div>`;
        } else {
            videoContent = `<div class="video-player">
                <video controls>
                    <source src="${video_url_signed}" type="video/mp4">
                </video>
            </div>`;
        }
    } else {
        // Empty state — show upload/paste UI (only in editor)
        if (!is_public) {
            videoContent = `<div class="video-placeholder">
                <div class="video-placeholder_url-section">
                    <div class="cc-settings-input">
                        <span class="cc-settings-input-label">${videoUrlLabel || 'Add URL to video'}</span>
                        <input type="text" class="cc-settings-field video-url-input" placeholder="${pasteYoutubeUrl}" />
                        <small>${videoUrlHint || 'Add URL to video on YouTube or Vimeo.'}</small>
                    </div>
                </div>
                <div class="or-hr"><span>or</span><hr></div>
                <div class="video-placeholder_file-section">
                    <input type="file" class="video-file-input" accept="video/mp4,video/x-m4v,video/*" style="display:none;" />
                    <a href="#" class="video-upload-btn video-tutorial-btn"><i class="icon icon-upload"></i>${uploadVideoFile}</a>
                    <small>${videoFileHint || 'Add file in mp4, ogg, mov, webm, wmv. File size not more than 500Mb'}</small>
                </div>
            </div>`;
        }
    }

    // Caption (editable in editor, static in public)
    let captionHtml = '';
    if (is_public) {
        if (video_caption) {
            captionHtml = `<figcaption class="video-container_caption">${video_caption}</figcaption>`;
        }
    } else {
        captionHtml = `<figcaption class="video-container_caption" placeholder="${videoPlaceholder}" contenteditable="true">${video_caption}</figcaption>`;
    }

    param.component = `
        <div class="video-container" data-video-type="${video_type}" data-video-url="${video_url}" data-video-thumbnail="${video_thumbnail}">
            <figure class="video-container_figure">
                ${videoContent}
                ${captionHtml}
            </figure>
        </div>`;

    if (is_public) {
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

/**
 * Extract YouTube video ID from various URL formats
 */
function extractYoutubeId(url) {
    let match = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
    if (match) return match[1];
    match = url.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
    if (match) return match[1];
    match = url.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
    if (match) return match[1];
    return '';
}

/**
 * Convert various YouTube URL formats to embed URL
 */
function convertToYoutubeEmbed(url) {
    let videoId = extractYoutubeId(url);
    if (videoId) {
        return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&iv_load_policy=3&autoplay=1`;
    }
    return url;
}

export {videoSection, convertToYoutubeEmbed, extractYoutubeId};
